module.exports = __webpack_public_path__ + "static/Squire-79902242776f18d513d85bea22c23916.jpg";